import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { ContractSign } from './types';

type Variables = { id: string; publicToken?: string };
type Response = ContractSign;

export const useContractSign = createQuery<Response, Variables, AxiosError>({
  queryKey: ['reservations/contract-sign'],
  fetcher: ({ id, publicToken }) => {
    return client
      .get(`v2/reservations/${id}/contract-sign`, {
        params: publicToken ? { public_token: publicToken } : undefined,
      })
      .then((response) => response.data.data);
  },
});
